import styled from 'styled-components';

const StyledAnalyticalExaminationFormFields = styled.div`
   display: flex;
   flex-direction: column;
   gap: 16px;
`;

StyledAnalyticalExaminationFormFields.displayName = 'StyledAnalyticalExaminationFormFields';

export { StyledAnalyticalExaminationFormFields };
